module.exports = __webpack_public_path__ + "b0b137b905ad636cebdcc71ef6b39ee6.svg";